import styled from 'styled-components';

import { colors } from '@/globalStyles';

export const ImageInsertWrapper = styled.div`
  display: grid;
  grid-gap: 10px;
  width: 100%;
  height: 100%;
`;

export const SectionImageInput = styled.input`
  display: none;
`;

export const SectionImageLabel = styled.label`
  font-size: ${props => (props.fontSize || '16px')};
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${props => (props.color || colors.black)};
`;

export const ImageInputWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  height: 49px;
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 30px;
  padding: 0 10px 0 20px;
  cursor: pointer;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${colors.black};

  background-color: #ffffff;
  border-radius: 4px;
`;

export const PanelHeaderWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 20px 1fr;
  grid-column-gap: 20px;
  align-items: center;
`;

export const PanelHeader = styled.div`
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
`;

export const TextSelectButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: center;
  justify-content: space-between;
  height: 49px;
  max-height: 49px;
  font-size: 14px;
  font-family: IBMPlexSans;
  font-weight: 400;
  border-radius: 4px;
  background-color: #f4f4f4;
  overflow: hidden;
  padding: 10px 20px;
  cursor: pointer;
  width: 100%;

  div {
    display: flex;
    height: 100%;
    align-items: center;
  }
`;
